import Card from '@/components/atoms/Card';
import LinkButton from '@/components/atoms/LinkButton';
import { cn } from '@/lib/utils';

export interface SimpleCardProps {
  align?: 'left' | 'center' | 'right';
  spacing?: 'small' | 'medium';
  children: React.ReactNode;
  url?: string;
  classNames?: {
    root?: string;
  };
}

const alignStyles = {
  left: 'items-start text-left',
  center: 'items-center text-center',
  right: 'items-end text-right',
} as const;

export function SimpleCard({
  align = 'left',
  children,
  url,
  classNames,
}: SimpleCardProps) {
  const hasUrl = !!url;

  const rootClassName = cn(
    align && alignStyles[align],
    'flex  self-stretch flex-col p-6',
    hasUrl ? 'h-full ' : 'h-auto',
    classNames?.root
  );

  const ContentWrapper = () => (
    <Card
      hasHoverEffect={hasUrl}
      classNames={{
        root: rootClassName,
      }}
    >
      {children}
    </Card>
  );

  if (!hasUrl) {
    return <ContentWrapper />;
  }

  return (
    <LinkButton
      href={url}
      noStyles
      classNames={{
        root: cn('sm:w-auto h-auto self-stretch'),
      }}
      data-tracker-component='card'
    >
      <ContentWrapper />
    </LinkButton>
  );
}
